export default function Loader() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 👈 transparent with opacity
        backdropFilter: 'blur(1px)', // optional: mild blur to make it nicer
      }}
    >
      <div role="status">
        <svg
          aria-hidden="true"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: '78px',
            height: '78px',
            color: '#C0C0C0',
            animation: 'spin 1s linear infinite',
          }}
        >
          {/* Background Circle */}
          <circle cx="50" cy="50.5" r="47.5" stroke="currentColor" strokeWidth="5.13" />
          {/* Foreground Arc */}
          <circle
            cx="50"
            cy="50.5"
            r="47.5"
            stroke="#2563eb"
            strokeWidth="5.13"
            strokeLinecap="round"
            strokeDasharray="80 299"
          />
        </svg>
        {/* screen reader only */}
        <span
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
        >
          Loading...
        </span>
      </div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
